#import "~/graphql/fragments/pageContent/defaultPageContent.graphql"
#import "~/graphql/fragments/pageContent/homePageContent.graphql"
#import "~/graphql/fragments/pageContent/subsidyOverviewPageContent.graphql"
#import "~/graphql/fragments/pageContent/subsidyPageContent.graphql"
#import "~/graphql/fragments/pageContent/subsidyInfoPageContent.graphql"
#import "~/graphql/fragments/pageContent/teamOverviewPageContent.graphql"
#import "~/graphql/fragments/pageContent/teamMemberPageContent.graphql"
#import "~/graphql/fragments/pageContent/toegewezenbijdragenPageContent.graphql"
#import "~/graphql/fragments/pageContent/deadlinesPageContent.graphql"
#import "~/graphql/fragments/pageContent/eventOverviewPageContent.graphql"
#import "~/graphql/fragments/pageContent/eventPageContent.graphql"
#import "~/graphql/fragments/pageContent/postOverviewPageContent.graphql"
#import "~/graphql/fragments/pageContent/postContent.graphql"
#import "~/graphql/fragments/pageContent/downloadPageContent.graphql"

query getPage($site: [String!], $uri: [String!], $slug: [String!], $section: [String], $now: [QueryArgument]) {
    entry(
        uri: $uri
        slug: $slug
        site: $site
        section: $section
    ) {
        __typename
        uri
        ... defaultPageContent
        ... homePageContent
        ... subsidyOverviewPageContent
        ... subsidyPageContent
        ... subsidyInfoPageContent
        ... teamOverviewPageContent
        ... teamMemberPageContent
        ... toegewezenbijdragenPageContent
        ... deadlinesPageContent
        ... eventOverviewPageContent
        ... eventPageContent
        ... postOverviewPageContent
        ... postContent
        ... downloadPageContent
    }
}
